import React from 'react'
import styled from 'styled-components'
import CreationToolSupercutField from '../../../../../../types/super-cut-field'
import WatermarkPositionSlider from '../../../../../form-fields/super-cut/watermark-position-slider'

const WatermarkPosition = styled(WatermarkPositionSlider)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSupercutField
}

const CreationCaptureInfoWatermarkPosition = ({ field }: Props) => {
    return (
        <WatermarkPosition
            {...{
                field,
            }}
        />
    )
}

export default CreationCaptureInfoWatermarkPosition
